import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap font-ui text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-sky focus-visible:ring-offset-2 focus-visible:ring-offset-surface disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-brand-royal text-brand-ice shadow-brand-glow hover:bg-brand-navy',
        secondary: 'bg-surface-card text-brand-ice hover:bg-surface-muted',
        outline: 'border border-brand-royal text-brand-ice hover:bg-brand-navy/20',
        ghost: 'text-brand-ice hover:bg-surface-muted/60',
        link: 'text-brand-sky underline-offset-4 hover:underline',
        success: 'bg-win text-white hover:brightness-95',
        warning: 'bg-gold text-surface hover:brightness-95',
        destructive: 'bg-loss text-white hover:brightness-95',
      },
      size: {
        default: 'h-10 px-4 py-2 rounded-btn',
        sm: 'h-9 px-3 rounded-btn',
        lg: 'h-11 px-8 rounded-btn',
        icon: 'h-10 w-10 rounded-btn',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, type = 'button', ...props }, ref) => {
    return (
      <button
        type={type}
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button, buttonVariants };
